import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import web from '../Assets/image2.png';
import laptopIcon from '../Assets/computer.svg';
import Container from 'react-bootstrap/Container';


//Half picture, half web dev explanation. Animation added. see data-aos

class HalfSection extends React.Component {
    render(){
        return(
            <div className="spacing yuckySection services">
            <Container >
                <Row >
                    <Col md={7} className="noPadMob">
                        <video  className="imagesFront div2 appImage" autoPlay playsInline muted loop data-aos={"fade"}>
                                <source src="https://compilelabs.s3.ca-central-1.amazonaws.com/videos/compileWeb.mp4" type="video/mp4" />
                        </video>
                    </Col>
                    <Col md={5} className="mergeBox2 " data-aos={"fade"}>
                        <img src={laptopIcon}   className="serviceIcon" />
                        <div className="innerBoxTitle">
                            Web Development
                        </div>
                        <div className="innerBoxText">
                            We rapidly design, build and test your websites. We also offer unlimited revisions so you can be fully satisfied with the product.
                        </div>
                    </Col>
                </Row>
            </Container>
            </div>
        );
    }

}



export default HalfSection;